<template>
  <div id="admin-positions">
    <v-card class="px-5 py-2 mt-4 mb-5 elevation-0">
      <v-row class="align-end">
        <v-col cols="12" md="3" class="my-1 py-0">
          <v-text-field
            v-model="filters.userId"
            label="UserId"
            :disabled="loading"
            hide-details
            clearable
            @keydown.enter="updateFilters"
          />
        </v-col>
        <v-col cols="12" md="3" class="my-1 py-0">
          <v-text-field
            v-model="filters._id"
            label="PositionId"
            :disabled="loading"
            hide-details
            clearable
            @keydown.enter="updateFilters"
          />
        </v-col>
        <v-col cols="12" md="2" class="my-1 py-0">
          <v-text-field
            v-model="filters.ticker"
            label="Ticker"
            :disabled="loading"
            hide-details
            clearable
            @keydown.enter="updateFilters"
          />
        </v-col>

        <v-col cols="12" md="2" class="my-1 py-0">
          <v-switch v-model="showOnlyRecreating" hide-details dense class="ml-5 mt-2">
            <template v-slot:label>
              <span>
                Pending Recreate
              </span>
            </template>
          </v-switch>
        </v-col>

        <v-col cols="12" md="2" class="my-1 py-0">
          <v-btn class="ml-5" color="primary" small :loading="loading" @click="updateFilters">
            Buscar
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card id="admin-positions" class="px-5 py-2 mt-4 mb-5 elevation-0">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        sort-by="createdAt"
        :sort-desc="true"
        class="admin-positions-table elevation-0 mt-2"
        mobile-breakpoint="0"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': defaultPaginationItemsPerPageOptions,
        }"
        :items-per-page="20"
        dense
        @update:options="loadItems"
      >
        <template v-slot:item.coreStatus="{ item }">
          {{ item.coreStatus }}
        </template>
        <template v-slot:item.corePendingRecreate="{ item }">
          <span v-if="item.corePendingRecreate" class="softGreen--text">
            <b>{{ item.corePendingRecreate }}</b>
          </span>
          <span v-else>
            {{ item.corePendingRecreate }}
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div>
            <a @click="adminPositionCoreRecreate(item)">Core recreate</a>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { adminGetPositions, adminPositionCoreRecreate } from '@/lib/api.js'
import tableMixin from '@/views/components/core/tableMixin.js'
import PositionMarketPrice from '@/views/components/common/positions/PositionMarketPrice'

export default {
  components: { PositionMarketPrice },
  mixins: [tableMixin],
  data: () => ({
    filters: {},
    showOnlyRecreating: true,
  }),
  computed: {
    defaultHeaders() {
      return [
        {
          text: 'createdAt',
          value: 'createdAt',
        },
        {
          text: 'userEmail',
          value: 'userId.email',
        },
        {
          text: 'userId',
          value: 'userId._id',
        },
        {
          text: 'positionId',
          value: '_id',
        },
        {
          text: 'ticker',
          value: 'ticker',
        },
        {
          text: 'type',
          value: 'type',
        },
        {
          text: 'country',
          value: 'country',
        },
        {
          text: 'exchange',
          value: 'exchange',
        },
        {
          text: 'coreStatus',
          value: 'coreStatus',
        },
        {
          text: 'corePendingRecreate',
          value: 'corePendingRecreate',
        },
        {
          text: 'coreErrors',
          value: 'coreErrors',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
        },
      ]
    },
  },
  watch: {
    showOnlyRecreating() {
      this.updateFilters()
    },
  },
  methods: {
    async loadItems() {
      this.loading = true
      try {
        const filter = JSON.parse(JSON.stringify(this.filters))
        if (!filter.ticker || filter.ticker === '') delete filter.ticker
        if (!filter._id || filter._id === '') delete filter._id
        if (!filter.userId || filter.userId === '') delete filter.userId

        if (this.showOnlyRecreating)
          filter.$or = [
            { coreStatus: { $in: ['recreating', 'pendingRecreate'] } },
            { corePendingRecreate: true },
          ]

        const { page, limit, sort } = this.getTablePaginationOptions(this.options)
        const response = await adminGetPositions({ filter, page, limit, sort })
        this.setTablePaginatedResponse(response)
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.loading = false
    },
    updateFilters() {
      this.setFirstPage()
      this.loadItems()
    },
    async adminPositionCoreRecreate(item) {
      this.loading = true

      try {
        await adminPositionCoreRecreate(item._id)

        this.loadItems()
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss">
#admin-positions {
  .items-flex {
    display: flex;
    &.flex-end {
      align-items: flex-end;
    }
  }
}
</style>
